module.exports = __webpack_public_path__ + "img/big-bag.492c962.svg";